import React, {useMemo} from "react";
import {Translate} from "../utils/types";
import getTranslate from "../utils/translate/translate";
import {getUserLanguage} from "../utils/user";

function Loading() {

    const translate: Translate = useMemo(() => { return getTranslate(getUserLanguage()) }, [])

    return (
        <div className="w-full h-full row justify-center items-center" style={{background: '#b2d7e091'}}>
            <div className={"flex flex-col items-center space-y-4"}>
                <span className="loader-v2"></span>
                <p className="text-gray-600 text-sm" style={{fontWeight: 'bold'}}>{translate.Text.loading}</p>
            </div>

        </div>
    );
}

export default Loading;
